export default __webpack_public_path__ + "0c9653228f552eb9c5bcf89bf7dee4ee.svg";